import { css } from "styled-components";
import token from "styled-token";
import { StyledIcon } from "../../components/Icon/Icon";
import { StyledText } from "../../components/Text/Text";
import { spaceMixin } from "../spaceMixin";
/** @class NumberRating */

/** @method */

export var NumberRatingMixin = function NumberRatingMixin(props) {
  var fontType = props.fontType;
  return token({
    fontSize: "fontSizes." + fontType,
    lineHeight: "lineHeights." + fontType,
    iconFontSize: "fontSizes.bodySmall",
    color: "colors.brand"
  }, function (tokens) {
    return css(["font-size:", "px;line-height:", "px;", "{font-size:", "px;color:", ";margin-bottom:-2px;vertical-align:baseline;}", "{margin-right:", ";}"], tokens.fontSize, tokens.lineHeight, StyledIcon, tokens.iconFontSize, tokens.color, StyledText, spaceMixin(0.5)(props));
  })(props);
};